import { FunctionComponent } from 'react'
import { DetailedData } from '../../../redux/requests/products/product.types'
import LineChart2, { LineChartData2 } from '../../molecules/LineChart/LineChart2'
import PieChartRow from '../PieChartRow'
import * as S from './styled'

type OwnProps = {
  //lineChartData: LineChartData
  weeks: number
  discarded: LineChartData2[]
  netPriceChartData: LineChartData2[]
  pieChartData: DetailedData[]
  allDiscarded: LineChartData2[]
  discardedWithRange: {
    [key: string]: { week: number; latest: number; high?: number; low?: number }[]
  }[]
}

type Props = OwnProps

export const ChartRow: FunctionComponent<Props> = ({
  //lineChartData,
  weeks,
  discarded,
  pieChartData,
  allDiscarded,
  discardedWithRange,
  netPriceChartData,
}) => {
  return (
    <S.Container>
      {discarded?.length && (
        <LineChart2 title={'Frånsorterat'} dataSets={discarded} withLifeWeekSwitch />
      )}
      {netPriceChartData?.length && <LineChart2 title={'Nettopris'} dataSets={netPriceChartData} />}
      {/* {discardedWithRange.length &&
        discardedWithRange.map((d, i) => (
          <LineChart3 title={Object.keys(d)[0]} dataSets={d} key={i} />
        ))} */}
      {/* <LineChart
        userAverages={lineChartData.userAverages}
        secondDataset={
          lineChartData.govStats ? lineChartData.govStats : lineChartData.movingAverages
        }
        type={'netPrice'}
        weeks={weeks}
      ></LineChart> */}
      {/* {!!lineChartData?.foderData?.length && (
        <LineChart
          userAverages={lineChartData.userAverages}
          secondDataset={
            lineChartData.govStats ? lineChartData.govStats : lineChartData.movingAverages
          }
          foderData={lineChartData.foderData}
          type={'foderNet'}
          weeks={weeks}
        />
      )} */}
      {!!pieChartData && <PieChartRow pieChartData={pieChartData} />}
    </S.Container>
  )
}

export default ChartRow
